<template>
  <div class="content">
    <!-- <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/highPro' }"
              >返回</el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row> -->
    <!-- 主体 -->
    <el-container class="content-container">
      <el-main
        style="
          height: 100%;
          padding: 0px !important;
          position: relative;
          width: 100%;
        "
      >
        <el-card style="height: 100% !important" class="aside">
          <div class="secend_content">
            <div class="entRisk_content">
              <div class="th_one">
                <div>设备名称：{{ personList.name }}</div>
                <div>设备编号：{{ personList.tsDtuId }}</div>
                <!-- <div>监测位置：########</div> -->
              </div>
              <div>
                联网状态:
                  <span style="color: #36c635" v-if="personList.online=='在线'">{{personList.online}}</span>
                  <span style="color: #f00" v-else-if="personList.online=='离线'">{{personList.online}}</span>
                  <span  v-else>{{personList.online}}</span>
              </div>
              <div>时间：{{ personList.createDate }}</div>
              <div class="th_one">
                <div>
                   压力监测
                  <span style="color: #c3f305">{{ personList.pressure }}</span>
                </div>
                <div>
                  移位监测
                  <span style="color: #c3f305">{{ personList.shift }}</span>
                </div>
                 <div>
                    倾角监测
                    <span style="color: #c3f305">{{personList.angle}}</span>
                  </div>
                  <div>
                    警报监测
                    <span style="color: #c3f305">{{personList.alarm}}</span>
                  </div>
              </div>
              <div style="position: relative">
                <img class="blue" src="../../../assets/image/white.png" alt />
                <img
                  class="round round_normal"
                  src="../../../assets/image/round.png"
                  alt
                />
               
                <div
                  style="
                    position: absolute;
                    top: 64px;
                    left: 64px;
                    color: #6b6b6b;
                  "
                >
                  <!-- <div v-if="item.connectedStatus=='离线'">{{item.connectedStatus}}</div> -->
                  <div>正常</div>
                  <div>24小时</div>
                </div>
              </div>
              <!-- <div>
                <el-button v-if="y == 1" type="warning" @click="node()"
                  >通知处理</el-button
                >
              </div> -->
            </div>
          </div>
          <!-- 表格内容 -->
          <div class="table_box">
            <div class="table_head">
              <div>
                <span>日期</span>
                <el-date-picker
                  v-model="search.date"
                  align="right"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  @change="dosearch"
                ></el-date-picker>
              </div>
              <!-- <el-button type="primary" @click="add">添加</el-button> -->
            </div>
            <div class="table_body">
              <el-table
                :data="tableDataEnd"
                :span-method="objectSpanMethod"
                border
                height="100%"
                style="width: 100%; margin-top: 20px"
              >
                <el-table-column prop="createDate" label="监测时间">
                </el-table-column>
                <el-table-column prop="label" label="监测类型">
                </el-table-column>
                <el-table-column prop="name" label="监测位置">
                </el-table-column>
             <el-table-column prop="tsSersorImei" label="设备号"> </el-table-column>
                <el-table-column prop="val" label="数据">
                    <template slot-scope="scope">
                      <span>{{scope.row.val}}</span>
                      <span>{{scope.row.unit}}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="操作">
                  <template slot-scope="scope" v-if="!scope.row.createDate">
                    <el-button
                      size="mini"
                      @click="handleEditEq(scope.$index, scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      size="mini"
                      type="danger"
                      @click="handleDeleteEq(scope.$index, scope.row)"
                      >删除</el-button
                    >
                  </template>
            </el-table-column> -->
              </el-table>
            </div>
            <!-- 弹出框 -->
            <el-dialog
              title="添加观测点"
              :visible.sync="temperVis"
              center
              :append-to-body="true"
              :lock-scroll="false"
              width="30%"
              style="height: 100%"
            >
              <el-form
                :model="creatForm"
                ref="creatForm"
                label-width="200px"
                :label-position="labelPosition"
              >
                <el-form-item label="名称">
                  <el-input
                    style="width: 217px"
                    v-model="creatForm.name"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item label="传感器设备号">
                  <el-input
                    style="width: 217px"
                    v-model="creatForm.tsSersorImei"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item label="监测类型:">
                  <el-select
                    v-model="creatForm.tsSersorType"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in types"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="temperVis = false">取 消</el-button>
                <el-button type="primary" @click="sumbitEquip('creatForm')"
                  >确 定</el-button
                >
              </div>
            </el-dialog>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
  data() {
    return {
      id: '',
      tableDataEnd: [],
      secondTitle: '',
      groupId: '',
      prevPage: '', //上一个页面
      // istowe: true,
      list: [],
      personList: {},
      curTime: util.myTime.formatTime(new Date(), 'YYYY年MM月dd日 HH:mm:ss'),
      nodata: false,
      istower: true,
      istowerPro: false,
      port: '',
      y: '1',
      addForm: {},
      search: {
        date: util.myTime.getCurTime(),
      },
      addFormVisible: false, // 弹出框是否显示
      dialogTitle: '', //弹出框标题
      labelPosition: 'right',
      types: [],
      spanArr: [],
      pos: 0,
      creatForm: {
        name: '',
        tsDtuId: '',
        useId: '',
        tsSersorImei: '',
        createBy: '',
        tsSersorType: '',
        usedFor: '',
      },
      temperVis: false, //添加温度测点弹出框
    }
  },
  mounted() {
    this.id = this.$route.params.id
    this.port = util.session.get('roleId')
    // if (this.port == '4') {
    //   this.groupId = util.session.get('groupId')
    //   this.istower = false
    //   this.getData()
    // }
    if (this.$route.name == 'deepPro' && this.port == '4') {
      this.istowerPro = true
    } else {
      this.istowerPro = false
    }
    // if (util.session.get('proId')) {
    //   this.groupId = util.session.get('proId')
    // }
    this.groupId = this.$route.params.proId
    this.getData()
    this.getList()
  },
  methods: {
    //获取数据
    getData() {
      var that = this
      myHttp
        .selectHighModulus({
          id: this.id,
        })
        .then(
          function (resp) {
            if (resp.data.code == '200') {
              that.personList = resp.data.data.ConcreteProject
              that.creatForm.tsDtuId = that.personList.tsDtuId
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function () {}
        )
    },
    getList() {
      var that = this
      this.search.projectId = this.groupId
      this.search.useId = this.id
      myHttp.selectHighModulusts(this.search).then(
        function (resp) {
          if (resp.data.code == '200') {
            console.log(resp)
            that.spanArr = []
            var list = resp.data.data.TsSensorRecord
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              if (i === 0) {
                that.spanArr.push(1)
                that.pos = 0
              } else {
                // 判断当前元素与上一个元素是否相同
                if (list[i].createDate === list[i - 1].createDate) {
                  that.spanArr[that.pos] += 1
                  that.spanArr.push(0)
                } else {
                  that.spanArr.push(1)
                  that.pos = i
                }
              }
              if(list[i].tsSersorType == '1'){
                list[i].val = list[i].offset||''
              }else if(list[i].tsSersorType == '2'){
                list[i].offset = list[i].offset||''
                list[i].strain = list[i].strain||''
                list[i].val = list[i].offset==''&&list[i].strain==''?'':list[i].offset+','+list[i].strain
                list[i].unit = list[i].offset==''&&list[i].strain==''?'':'°'
              }else if(list[i].tsSersorType == '3'){
                list[i].val = list[i].offset||''
              }
            }
            that.tableDataEnd = list
            //   that.totalItems = resp.data.data.PageInfo.total
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.dataText = '暂无数据'
          }
        },
        function () {}
      )
    },
    //字典表（检测类型）
    getDict() {
      var that = this
      myHttp
        .getDictByType({
          type: 'monitor_type',
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            that.types = resp.data.data.dictList
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    node() {
      // console.log(deviceId)
      // var that = this
      // myHttp
      //   .updateInformStatus({
      //     projectId: this.groupId,
      //     deviceId: deviceId
      //   })
      //   .then(
      //     function(resp) {
      //       if (resp.data.code == '200') {
      //         that.$message({
      //           type: 'success',
      //           message: '操作成功'
      //         })
      //         that.getData()
      //       } else {
      //         that.$message.error(resp.data.msg)
      //       }
      //     },
      //     function() {}
      //   )
      this.$message({
        message: '操作成功',
        type: 'success',
      })
      this.y = 0
    },
    goBack() {
      this.$router.go(-1)
      //window.history.back()
    },
    bind() {
      this.$router.push({
        path: '/bindHigh',
      })
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    add() {
        this.getDict()
        var that = this
        this.temperVis = true
        this.creatForm.tsSersorImei = ''
        // this.creatForm.tsDtuId = ''
        this.creatForm.useId = this.id
        this.creatForm.id=''
        this.creatForm.name = ''
        this.creatForm.tsSersorType = ''
        this.creatForm.createBy = util.session.get('user').id
        this.creatForm.usedFor = 2
      },
       /**
     * 提交观测点
     */
    sumbitEquip(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.creatForm.id==''){
               myHttp.postTsDtuSensorCGQ(that.creatForm).then(
            function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('添加成功')
                that.temperVis = false
                that.getList()
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function () {}
          )
          }else{
             myHttp.updateTsDtuSensorCGQ(that.creatForm).then(
            function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('修改成功')
                that.temperVis = false
                 that.getList()
              } else {
                that.$message.error(resp.data.msg)
              }
            },
            function () {}
          )
          }
        }
      })
    },   //编辑
      //编辑
    handleEditEq(index, row) {
       this.getDict()
        this.temperVis=true
        this.creatForm.tsSersorImei = row.tsSersorImei
      // this.creatForm.tsDtuId = ''
        this.creatForm.useId = this.id
        this.creatForm.name = row.name
        this.creatForm.id = row.tsDtuSensorId
        this.creatForm.tsSersorType = row.tsSersorType
        this.creatForm. updateBy = util.session.get('user').id
        this.creatForm.usedFor = 2
    },
    //删除
    handleDeleteEq(index,row){
        var that = this
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            myHttp.deleteTsDtuSensorCGQ({
                id: row.tsDtuSensorId,
                updateBy:util.session.get('user').id
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    that.$message.success('删除成功')
                     that.getList()
                } else {
                    that.$message.error(resp.data.msg)
                }
            })
        })
    },
    currentChangePage1() {},
    dosearch(){
      // console.log(111)
      this.tableDataEnd =[]
      this.getList()
    }
  },
}
</script>
<style>
@import '../../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 20px 35px 20px -12px;
  height: 40px;
  justify-content: space-between;
}
.secend_content {
  margin-top: 30px;
  /* margin-bottom: 30px; */
  background: #f5f5f5;
  padding: 0 50px;
  overflow: hidden;
  height: 180px;
}
.entRisk_content {
  width: 95%;
  /* height: ; */
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 5px solid #f5f5f5;
}
.entRisk_bot {
  width: 95%;
  background: #011c56;
}
.left_head {
  /* width: 20%; */
  display: flex;
  color: #fff;
}
.th_one {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 30%;
  text-align: left;
}
.spealic {
  background: #fff;
  padding: 0 36px;
  display: flex;
  width: 98%;
  margin: 0 auto;
  /* padding-bottom: 30px; */
  height: 60px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 10px;
}
.round {
  display: block;
  position: absolute;
  display: block;
  top:0;
}
.round_normal {
  animation: rotate 6s linear infinite;
}
@keyframes rotate {
  0% {
    transform: rotateZ(0deg); /*从0度开始*/
  }
  100% {
    transform: rotateZ(360deg); /*360度结束*/
  }
}
.text {
  text-align: left;
}
.hand {
  cursor: pointer;
}
.hand:hover {
  color: #0085ff;
}
.imgs {
  width: 100%;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  border: 1px solid #000;
}
.imgs > img {
  width: 200px;
  /* height: 200px; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.imgs > div {
  width: 200px;
  /* height: 200px; */
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-60%, -50%);
  font-weight: bolder;
  color: #6b6b6b;
}
.table_box {
  height: calc(100% - 210px);
  width: 100%;
}
.table_head {
  height: 100px;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* border-bottom: 2px solid #f5f5f5; */
}
.table_body {
  height: calc(100% - 120px);
}
</style>